var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_1443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.768066 0H24.7681V24H0.768066V0Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81152 1.04297H12.2463V11.4778H1.81152V1.04297Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2898 1.04297H23.7246V11.4778H13.2898V1.04297Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81152 12.5215H12.2463V22.9563H1.81152V12.5215Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2898 12.5215H23.7246V22.9563H13.2898V12.5215Z",
    fill: "#FFBA08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_1443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.768066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/microsoft_logo.80f4d4438e1dfc86ed5b6a3bb9c8c126.svg";
export { ForwardRef as ReactComponent };